import { notifications } from "@mantine/notifications";
import { queryOptions, useMutation, useQueryClient } from "@tanstack/react-query";

import { ApiError } from "@kansai-ai-hub/api-client";
import type { MemberProfile, MemberProfileUpdate } from "@kansai-ai-hub/api-client";

import { apiClient } from "@/lib/api-client";

export const memberProfileKeys = {
  all: ["member-profile"] as const,
};

/** 会員の自己プロフィール（自組織の得意業界・得意技術）。 */
export function memberProfileQueryOptions() {
  return queryOptions({
    queryKey: memberProfileKeys.all,
    queryFn: () => apiClient.get<MemberProfile>("/api/v1/users/me/profile"),
    staleTime: 60_000,
  });
}

/** 会員の得意業界・得意技術を更新する。成功時は会員ホームのおすすめにも反映される。 */
export function useUpdateMemberProfileMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: MemberProfileUpdate) =>
      apiClient.patch<MemberProfile>("/api/v1/users/me/profile", { body: input }),
    onSuccess: (profile) => {
      // 即時反映 + 念のため再取得（会員ホームの業界レーンが新しい得意業界で再計算される）。
      qc.setQueryData(memberProfileKeys.all, profile);
      void qc.invalidateQueries({ queryKey: memberProfileKeys.all });
      notifications.show({ color: "green", message: "得意分野を更新しました" });
    },
    onError: (err: Error) => {
      const message = err instanceof ApiError ? err.message : "更新に失敗しました";
      notifications.show({ color: "red", title: "エラー", message });
    },
  });
}
